import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Listing from '../components/Common/Listing/Listing';
import _ from "lodash"
import { listTrackings } from '../actions/homeActions';
import { getForms } from '../actions/formActions';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
ChartJS.register(
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const Home = (props) => {
  const listFormKey = "home_tracking_list_form";
  const dispatch = useDispatch();
  const homeState = useSelector((state) => state.home);
  const formState = useSelector((state) => state.forms);
  const { formJson = {} } = formState;
  const listingJson = formJson[listFormKey] || {};
  const { listing = {}, chartData = {} } = homeState;
  const { chartValues = [], lastDaysChange = [] } = chartData;
  const { headers = [], data: listData = [], meta = {} } = listing;
  const [fetchingList, setFetchingList] = useState(!(_.isEmpty(listData) || _.isEmpty(listingJson)));

  useEffect(() => {
    if (!_.isEmpty(listData) && fetchingList) {
      setFetchingList(false);
    }
  }, [listData])

  useEffect(() => {
    if (!_.isEmpty(listingJson))
      listApi();
  }, [listingJson]);

  useEffect(() => {
    dispatch(getForms(listFormKey));
  }, []);

  const listApi = () => {
    const listPayload = { enabled: true, fetchWithLive: true, fetchWithChart: true, status: 'OPENED', fetchLiveTrackingStocks: true };
    dispatch(listTrackings(listPayload, listFormKey));
  }

  const getTrackingChart = (_chartData, title = '% Changes to Buy Price') => {
    const getRandomColor = () => {
      const r = Math.floor(Math.random() * 255);
      const g = Math.floor(Math.random() * 255);
      const b = Math.floor(Math.random() * 255);
      return {
        border: `rgb(${r}, ${g}, ${b})`,
        background: `rgba(${r}, ${g}, ${b}, 0.5)`
      };
    };

    const line_options = {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: title,
        },
      },
    };
    const line_labels = Array.from(new Set(
      _chartData.flatMap(({ data = [] }) => data.map(({ date }) => date))
    )).sort((a, b) => a.localeCompare(b));
    const line_data = {
      labels: line_labels,
      datasets:
        _chartData.map(datum => {
          const { name = '', data = [] } = datum;
          const dateValueMap = data.reduce((accum, item) => {
            const { date = '', value = null } = item;
            if (date) {
              accum[date] = value;
            }
            return accum;
          }, {});
          const color = getRandomColor();
          return {
            label: name,
            data: line_labels.map(date => (Object.prototype.hasOwnProperty.call(dateValueMap, date) ? dateValueMap[date] : null)),
            borderColor: color.border,
            backgroundColor: color.background,
            spanGaps: false,
          }
        })
    };

    return <div className="col-md-12">
      <Line options={line_options} data={line_data} />
    </div>

  }

  return (<section
  // className="charts mt-4"
  >
    {chartValues.length > 0 ? getTrackingChart(chartValues) : ''}
    {/* {lastDaysChange.length > 0 ? getTrackingChart(lastDaysChange, 'Last days change %') : ''} */}
    <div className="row">

      <div className="col-md-12">
        <Listing
          headers={headers}
          data={listData}
          onSearch={listApi}
          meta={meta}
          fetchingList={fetchingList}
        />
      </div>
    </div>

  </section>)
};

export default Home;
